import { render, staticRenderFns } from "./BINCardDocumentList.vue?vue&type=template&id=735a7418&lang=pug&"
import script from "./BINCardDocumentList.vue?vue&type=script&lang=js&"
export * from "./BINCardDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports